import { set } from 'date-fns';
import { isNil, orderBy } from 'lodash';
import Authentication from '../module/Authentication';
import Common from '../module/Common';




export class ApiService {
    static activeJobs = [];
    static recentCompletedJobs = [];
    static activeRoutes = [];
    static filteredJobs = [];


    clearCachedData() {
        ApiService.activeJobs = [];
        ApiService.recentCompletedJobs = [];
        ApiService.activeRoutes = [];
        ApiService.filteredJobs = [];
    }


    loadActiveJobs(stateId, clientCode) {
        if(!stateId || !clientCode) {
            return Promise.resolve([]);
        }
        
        if(ApiService.activeJobs.length) {
            return Promise.resolve(ApiService.activeJobs);
        }

        const user = Authentication.CheckStoredSession();
        
        return fetch(`api/Jobs/ByAccount/${stateId}/${clientCode}`, {
            headers: {
                Authorization: 'Bearer ' + user.jwtToken
            }
        })
        .then(response => {
            return response.json();
        })
        .then(activeJobs => {
            ApiService.activeJobs = activeJobs?.map(job => {
                // Null values for pickupDistance and deliveryDistance should be considered to have the highest value. We set 9999 to make the sorting easier(just dont show the value in the UI).
                return {
                    ...job,
                    pickupDistance: isNil(job.pickupDistance) ? 9999 : job.pickupDistance,
                    deliveryDistance: isNil(job.deliveryDistance) ? 9999 : job.deliveryDistance,
                };
            });
            
            return Promise.resolve(ApiService.activeJobs);
        })
        .catch((error) => {
            Promise.reject('Could not load active jobs data');
        });
    }


    loadRecentCompletedJobs(stateId, clientCode) {
        if(!stateId || !clientCode) {
            return Promise.resolve([]);
        }
        
        if(ApiService.recentCompletedJobs.length) {
            return Promise.resolve(ApiService.recentCompletedJobs);
        }

        const user = Authentication.CheckStoredSession();
        return fetch(`api/RecentCompletedJobs/RecentCompleted/${stateId}/${clientCode}`, {
            headers: {
                Authorization: 'Bearer ' + user.jwtToken
            }
        })
        .then(response => {
            return response.json();
        })
        .then(recentCompletedJobs => {
            ApiService.recentCompletedJobs = recentCompletedJobs;
            return Promise.resolve(recentCompletedJobs);
        })
        .catch((error) => {
            Promise.reject('Could not load recent completed jobs data');
        });
    }


    loadActiveRoutes(stateId, clientCode) {
        if(!stateId || !clientCode) {
            return Promise.resolve([]);
        }
        
        if(ApiService.activeRoutes.length) {
            return Promise.resolve(ApiService.activeRoutes);
        }

        const user = Authentication.CheckStoredSession();
        return fetch(`api/jobs/ActiveRoutes/${stateId}/${clientCode}`, {
            headers: {
                Authorization: 'Bearer ' + user.jwtToken
            }
        })
        .then(response => {
            return response.json();
        })
        .then(activeRoutes => {
            ApiService.activeRoutes = activeRoutes;
            return Promise.resolve(activeRoutes);
        })
        .catch((error) => {
            Promise.reject('Could not load active routes data');
        });
    }


    searchJobs(searchString, searchBy, startDate, range) {
        if(ApiService.filteredJobs.length) {
            return Promise.resolve(ApiService.filteredJobs);
        }

        const user = Authentication.CheckStoredSession();
        return fetch('api/Search', {
            method: "POST",
            headers: {
                Authorization: 'Bearer ' + user.jwtToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                reference: searchString,
                referenceType: searchBy,
                startDate: startDate,
                range: range
            })
        })
        .then(response => {
            return response.json();
        })
        .then(filteredJobs => {
            ApiService.filteredJobs = filteredJobs;
            return Promise.resolve(filteredJobs);
        })
        .catch((error) => {
            Promise.reject('Could not search jobs');
        });
    }


    /**
     * For now, we just get the jobs from the cached data instead of getting it from the server.
     * Also sort the jobs by `dateCompleted` in ascending order then autogenerate value for `dropNumber`.
     * @param {*} filters { timeCompletedDateFrom?: Date; timeCompletedDateTo?: Date; }
     */
    loadDriverCompletedJobs(driverNumber, filters) {
        let driverCompletedJobs = ApiService.recentCompletedJobs?.filter(job => job.driverNumber == driverNumber) ?? [];

        if(filters.timeCompletedDateFrom && filters.timeCompletedDateTo) {
            driverCompletedJobs = driverCompletedJobs.filter(job => {
                const dateFrom = set(filters.timeCompletedDateFrom, { hours: 0, minutes: 0, seconds: 0 });
                const dateTo = set(filters.timeCompletedDateTo, { hours: 23, minutes: 59, seconds: 59 });
                const date = new Date(job.timeCompletedDate);
                
                if(date >= dateFrom && date <= dateTo) {
                    return job;
                }
            })
        }
        
        // Sort jobs by `timeCompletedDate`
        driverCompletedJobs = orderBy(driverCompletedJobs, 'timeCompletedDate', 'asc');

        // Generate value for `dropNumber`
        driverCompletedJobs = driverCompletedJobs?.map((job, index) => {
            return {
                ...job,
                dropNumber: index+1
            };
        })

        return driverCompletedJobs;
    }

}